import "animate.css";

import {
	Box,
	Button,
	Grid,
	TextField,
	MenuItem,
	FormControl,
	InputLabel,
	Select,
} from "@mui/material";

function AddIngredientRow({ ingredients, updateIngredient, addIngredientRow }) {
	return (
		<Grid container spacing={1} justifyContent="center">
			<Grid item xs={5}>
				{ingredients.map((item, i) => (
					<Box key={i} mb={1}>
						<TextField
							fullWidth
							label="Ingredient"
							value={item.ingredient}
							onChange={(e) => updateIngredient(i, "ingredient", e.target.value)}
						/>
					</Box>
				))}
			</Grid>

			<Grid item xs={4}>
				{ingredients.map((item, i) => (
					<Box key={i} mb={1}>
						<TextField
							fullWidth
							label="Quantity"
							value={item.quantity}
							onChange={(e) => updateIngredient(i, "quantity", e.target.value)}
						/>
					</Box>
				))}
			</Grid>

			<Grid item xs={2.5}>
				{ingredients.map((item, i) => (
					<Box key={i} mb={1}>
						<FormControl fullWidth>
							<InputLabel>Type</InputLabel>
							<Select
								label="Measurement"
								value={item.type}
								onChange={(e) => updateIngredient(i, "type", e.target.value)}
							>
								<MenuItem value={"g"}>g</MenuItem>
								<MenuItem value={"dl"}>dl</MenuItem>
								<MenuItem value={"ml"}>ml</MenuItem>
								<MenuItem value={"st"}>st</MenuItem>
							</Select>
						</FormControl>
					</Box>
				))}
			</Grid>

			<Grid item xs={12}>
				<Button onClick={addIngredientRow} fullWidth variant="outlined">
					Add more ingredients
				</Button>
			</Grid>
		</Grid>
	);
}
export default AddIngredientRow;
